import React from "react";
import { useTranslation } from "react-i18next";

// Simple, theme‑aware header card with a marquee of clickable partner logos + names
const partners = [
  { name: "وزارة الصناعة والتكنولوجيا المتقدمة", url: "https://moiat.gov.ae/en/", logo: "https://d19ff1canfg6xu.cloudfront.net/madeinemirates-assets/uploads/2025/03/UAE_MOEDT_Horizontal_RGB_AE-1024x171.jpg" },
  { name: "وزارة الثقافة", url: "https://mcy.gov.ae/en/", logo: "https://d19ff1canfg6xu.cloudfront.net/madeinemirates-assets/uploads/2024/09/UAE_MOC_Vertical_RGB_AE-768x504.jpg" },
  { name: "Invest in Abu Dhabi", url: "https://www.investinabudhabi.ae/en", logo: "https://d19ff1canfg6xu.cloudfront.net/madeinemirates-assets/uploads/2025/02/download-52-e1742366686114.png" },
  { name: "ADNOC", url: "https://www.adnoc.ae/", logo: "https://d19ff1canfg6xu.cloudfront.net/madeinemirates-assets/uploads/2025/02/ADNOC-Logo-Make-It-In-The-Emirates-1-e1742366737376.png" },
  { name: "Tawazun", url: "https://www.tawazun.gov.ae/", logo: "https://d19ff1canfg6xu.cloudfront.net/madeinemirates-assets/uploads/2025/04/tawazun.png" },
  { name: "NMDC Group", url: "https://nmdc-group.com/en/", logo: "https://d19ff1canfg6xu.cloudfront.net/madeinemirates-assets/uploads/2025/04/NMDC-Group-1024x724.png" },
  { name: "KEZAD Group", url: "https://www.kezadgroup.com/", logo: "https://d19ff1canfg6xu.cloudfront.net/madeinemirates-assets/uploads/2025/04/KEZAD_Group_Logo_POADPG_RGB_Pos-1024x339.png" },
  { name: "Emirates Development Bank", url: "https://edb.gov.ae/", logo: "https://d19ff1canfg6xu.cloudfront.net/madeinemirates-assets/uploads/2025/04/EDB-logo.png" },
  { name: "ADEX", url: "https://www.adex.ae/", logo: "https://d19ff1canfg6xu.cloudfront.net/madeinemirates-assets/uploads/2025/04/logo.png" },
  { name: "ADCB", url: "https://www.adcb.com/en/personal/", logo: "https://d19ff1canfg6xu.cloudfront.net/madeinemirates-assets/uploads/2025/04/ADCB_Master_RGB_Pos-768x229.jpg" },
  { name: "Mubadala", url: "https://www.mubadala.com/", logo: "https://d19ff1canfg6xu.cloudfront.net/madeinemirates-assets/uploads/2025/04/mubadala-investment-company-seeklogo.png" },
  { name: "IHC", url: "https://www.ihcuae.com/davos/index.html", logo: "https://d19ff1canfg6xu.cloudfront.net/madeinemirates-assets/uploads/2025/04/IHC_logo_EN_AR_horizontal_page-0001-scaled-e1745221659503.jpg" },
  { name: "HUB71", url: "https://www.hub71.com/", logo: "https://d19ff1canfg6xu.cloudfront.net/madeinemirates-assets/uploads/2025/05/HUB71-LOGOS_HUB71-SECONDARY-LOGO-1024x468.png" },
];

const StrategicPartnersShowcase = () => {
  const { t } = useTranslation();

  return (
    <section id="strategic-partners" style={{ padding: "80px 10%", backgroundColor: "#fff" }}>
      <style>{`
        .sp-card{background:#fff;border-radius:12px;overflow:hidden;box-shadow:0 4px 20px rgba(0,0,0,.08)}
        .sp-header{background: var(--uae-gradient); color:#fff; padding: 40px 60px}
        .sp-title{font-size:22px;font-weight:700;margin:0 0 10px}
        .sp-sub{opacity:.9;font-size:16px;line-height:1.6;margin:0}
        .sp-track{position:relative;overflow:hidden;padding:24px 0;background:#fff}
        .sp-marquee{display:flex;gap:28px;min-width:100%;animation:scrollX 32s linear infinite}
        .sp-item{flex:0 0 auto;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:8px;border:1px solid #e6e0f7;background:#fff;color:var(--uae-green);padding:14px 18px;border-radius:16px;text-decoration:none;font-weight:600;box-shadow:0 4px 10px rgba(0,0,0,.04);min-width:160px}
        .sp-item img{height:48px;width:auto;object-fit:contain}
        .sp-name{display:block;font-size:14px;line-height:1.25;color:var(--uae-green);text-align:center;max-width:180px}
        .sp-track:hover .sp-marquee{animation-play-state:paused}
        @keyframes scrollX{0%{transform:translateX(0)}100%{transform:translateX(-50%)}}
        @media (max-width:900px){.sp-header{padding:28px}}
      `}</style>

      <div className="sp-card">
        <div className="sp-header">
          <h2 className="sp-title">{t("PartnersSection.StrategicTitle", { defaultValue: "Strategic Partners" })}</h2>
          <p className="sp-sub">{t("PartnersSection.StrategicSub", { defaultValue: "Our strategic partners and sponsors supporting Make it in the Emirates." })}</p>
        </div>

        <div className="sp-track">
          {/* duplicate the list to make a seamless marquee */}
          <div className="sp-marquee">
            {[...partners, ...partners].map((p, i) => (
              <a key={i} href={p.url} target="_blank" rel="noreferrer" className="sp-item" aria-label={p.name}>
                <img src={p.logo} alt={p.name} />
                <span className="sp-name">{p.name}</span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default StrategicPartnersShowcase;
